<script setup>
import { watch, ref } from 'vue'
import 'animate.css';

// const emit = defineEmits('networkStatut')
let isOnline = ref(navigator.onLine)

watch(isOnline, () => {
    isOnline.value = navigator.onLine
})

window.addEventListener('online', () => {
    isOnline.value = true
})

window.addEventListener('offline', () => {
    isOnline.value = false
    // refreshPage()
})

const refreshPage = () => {
    window.location.reload()
}
</script>

<template >
    <Transition>
        <template v-if="!isOnline">
            <div class="z-9999 flex justify-center items-center p-1 animate__animated"
                :class="isOnline ? 'animate__bounceOutLeft' : 'animate__bounceInLeft'">
                <div class="flex items-center space-x-2">
                    <div>
                        <div class="progress"></div>
                    </div>
                    <div class="flex flex-col text-xxs leading-none font-semibold">
                        <span>Mode hors ligne</span>
                        <span>En attente de reconnexion...</span>
                    </div>
                </div>
            </div>
        </template>
    </Transition>
</template>

<style>
.progress {
    width: 27px;
    height: 20px;
    -webkit-mask: linear-gradient(90deg, #000 70%, #0000 0) 0% 100% / 20% 20%,
        linear-gradient(90deg, #000 70%, #0000 0) 25% 100% / 20% 40%,
        linear-gradient(90deg, #000 70%, #0000 0) 50% 100% / 20% 60%,
        linear-gradient(90deg, #000 70%, #0000 0) 75% 100% / 20% 80%,
        linear-gradient(90deg, #000 70%, #0000 0) 100% 100% / 20% 100%;
    -webkit-mask-repeat: no-repeat;
    background: linear-gradient(#e2e3e5 0 0) left/0% 100% no-repeat #ffffff;
    animation: progress-0beb2c 2.8s infinite steps(6);
}

@keyframes progress-0beb2c {
    100% {
        background-size: 120% 100%;
    }
}
</style>